var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-top":"10px"}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$route.query.name))]),_vm._v(" "),_c('iframe',{staticStyle:{"width":"100%","height":"90vh"},attrs:{"id":"frame","src":_vm.$route.query.url}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc7a0806","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/live/live.vue
// module id = null
// module chunks = 